module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "size": "medium"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Modifier le commentaire")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', {
    attrs: {
      "id": "temContent"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "large-4 light-grey-button",
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    staticClass: "large-4 large-offset-2 validate",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("Valider")])]), _vm._v(" "), _c('br')])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d6b4a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/text-edit-modal.vue
// module id = 742
// module chunks = 0